/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeARightIcon16Regular = forwardRef('ArrowShapeARightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.396 6.587a2 2 0 0 1 0 2.828l-5.689 5.689c-.63.63-1.707.183-1.707-.707V12H2.75A1.75 1.75 0 0 1 1 10.25v-4.5C1 4.783 1.784 4 2.75 4H7V1.604C7 .713 8.077.266 8.707.897l5.69 5.69Zm-1.06 1.767a.5.5 0 0 0 0-.707L8.5 2.811V4.75a.75.75 0 0 1-.75.75h-5a.25.25 0 0 0-.25.25v4.5c0 .138.112.25.25.25h5a.75.75 0 0 1 .75.75v1.94l4.836-4.836Z" })));
});
